export const panelSx = {
  backgroundColor: '#1e1e1e',  // Boxの背景色をダークグレーに設定します。
  boxSizing: 'border-box',     // 高さ計算にパッドが含まれていることを確認する。
  display: 'flex',             // Boxにフレックスボックスレイアウトを適用し、フレックスコンテナにします。
  flexDirection: 'column',     // 子要素を縦方向（上から下）に配置します。
  alignItems: 'center',        // 子要素を交差軸（列レイアウトの場合は垂直方向）で中央に揃えます。
  gap: 0.5,                      // 子要素間に隙間を設けます（デフォルトでMUIの単位「1」は8px）。
  padding: 0.5,                  // Boxの内側にパディングを追加します（デフォルトでMUIの単位「1」は8px）。
  width: '100%',               // Boxの幅を親要素の水平方向に最大限まで広げます。
  height: '100%',              // Boxの高さを親要素の垂直方向に最大限まで広げます。
  overflow: 'auto',            // コンテンツがBoxの高さを超えた場合にスクロールできるようにし、必要に応じてスクロールバーを表示します。
};
